<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';

export default {
     init: (payload) => {

            const el = document.body;
            el.removeAttribute("class");
            $('.modal').modal('hide');

            payload.domain = Endpoints.domain;
            

            
    },
    methods:{
        save: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

            let data = JSON.parse(JSON.stringify(this.data));
            if (data.price){
                data.price = data.price.toString().split(".").join("").split(",").join(".").split("R$ ").join("");
            }
            if(this.data.customerUser.dateBirth){
                let day,month,year;
                day = (this.data.customerUser.dateBirth.slice(0,2));
                month = (this.data.customerUser.dateBirth.slice(3,5));
                year = (this.data.customerUser.dateBirth.slice(6,10));

                data.customerUser.dateBirth = new Date();
                data.customerUser.dateBirth.setDate(day);
                data.customerUser.dateBirth.setMonth(month-1);
                data.customerUser.dateBirth.setFullYear(year);
            }       

            //GET COMPANY ID
            let company = this.$session.get('user').companyUser.company._id;
            data.customerUser.company = company;

            let formData = new FormData();

            formData.append('file', this.file);
            formData.append('jsonData', JSON.stringify(data));
          
            if(data.customerUser.company && data.customerUser.company.length > 0){

                Request.do(this, this.data._id ? 'PUT' : 'POST', Request.getDefaultHeader(this), formData, `${Endpoints.systemUsers.systemUserFormdata}${this.data._id ? this.data.email : ''}`,
                (response)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle');
                    this.$eventHub.$emit('refreshList');
                    if (!data._id){
                        this.flashMessage.success(
                            this.configMessage(this.$t('string.msg.trucker.register.title.success'), this.$t('string.msg.trucker.register.message.success'), 'top left', 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.trucker.register.message.success')),
                            destroyed: this.clearText()
                        })
                    } else{
                        this.flashMessage.info(
                            this.configMessage(this.$t('string.msg.trucker.register.title.alter'), this.$t('string.msg.trucker.register.message.alter'), 'top left', 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.trucker.register.message.alter')),
                            destroyed: this.clearText()
                        })
                    } 
                    state.data._id = response.result._id;
                    state.valuekey += 1;
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                });

            }
        },
        handleFileUpload(){
            this.file = this.$refs.file.files[0];
        },
        showPhoto: function(url){
            this.photoURL = url;
            $('#modalPhoto').modal('show');
        },
        getTrucks: function(id){
             Request.do(this, 'POST', Request.getDefaultHeader(this), {truckDriver:id}, `${Endpoints.trucks.listByType}`,
                (response)=>{//SUCCESS CALLBACK
                    return response.results;
                },
                (error)=>{//ERROR CALLBACK
                return null;
                });
        },
        selectItem: function(item){
            this.data = JSON.parse(JSON.stringify(item));
            this.data.firstName = Common.camelize(this.data.firstName);
            this.data.lastName = Common.camelize(this.data.lastName);
            
            this.data.customerUser.dateBirth = new Date(this.data.customerUser.dateBirth).toLocaleDateString();
            this.data.customerUser.oldCnhPhotoURL = this.data.customerUser.cnhPhotoURL;

            Request.do(this, 'POST', Request.getDefaultHeader(this), {truckDriver:item._id}, `${Endpoints.trucks.listByType}`,
                (response)=>{//SUCCESS CALLBACK
                   this.trucks = response.results;
                },
                (error)=>{//ERROR CALLBACK
                });

            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
         

        },
        archive: function(response){
            if (response==1){
                $('#spinner').modal('toggle');
                this.errors = [];
                this.messageIdToast = null;
                let state = this;
                // this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '');
                Request.do(this, 'DELETE', Request.getDefaultHeader(this), this.data, `${Endpoints.systemUsers.systemUser}${this.data.email}`,
                    (companyResponse)=>{//SUCCESS CALLBACK

                        $('#spinner').modal('toggle');

                        this.$eventHub.$emit('refreshList');

                        this.flashMessage.warning(
                            this.configMessage(this.$t('string.msg.trucker.register.title.filed'), this.$t('string.msg.trucker.register.message.filed'), 'top left', 2500),
                        {
                            mounted: this.showText(this.$t('string.msg.trucker.register.message.filed')),
                            destroyed: this.clearText()
                        })
                        
                        setTimeout(function(){ 
                            location.reload();
                            this.$forceUpdate();
                        },500);  
                    },
                    (error)=>{//ERROR CALLBACK
                        $('#spinner').modal('toggle');
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            $('#toast').modal('show');
                        }
                });
            }
        },
         confirmArchive: function(item){
            this.titleToast = this.$t("string.msg.confirm");
            this.messageToast = this.$t("response.archive.trucker.confirmation");
            this.cancelText = this.$t("string.msg.cancel");
            this.yesText = this.$t("string.msg.yes");
            $('#confirmationModal').modal('show');
        },
        clearForm: function(){
            this.errors = [];
            this.data = {
                firstName: null,
                lastName: null,
                email: null,
                password: null,
                primaryPhone: null,
                type: "USER-CUSTOMER",
                customerUser: {
                    subtype: "TRUCK_DRIVER",
                    dateBirth: null,
                    document: null,
                    cnh: null,
                    rg: null,
                    selfiePhotoURL: 'xxxxx',
                    obsCNH: null,
                    gender: null,
                    company: null,
                    oldCnhPhotoURL: null
                }
            }
        },
        checkForm: function (e) {
            this.errors = [];
            if (!this.data.firstName) {
                this.errors.push(this.$t('response.trucker.register.name.required'));
            }
            if (!this.data.lastName) {
                this.errors.push(this.$t('response.trucker.register.lastname.required'));
            }
            if (!this.data.primaryPhone) {
                this.errors.push(this.$t('response.trucker.register.phone.required'));
            }
            if (!this.data._id && !this.data.password) {
                this.errors.push(this.$t('response.trucker.register.password.required'));
            }
            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.save();
            }
        },
         showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        configMessage :function(title, message, position, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: window.innerWidth /60,
                y: window.innerHeight /1.3,
                time: time,
            }
            return config
        },
        
         camelize: Common.camelize,
         toUpperCase: Common.toUpperCase,
    }
}
</script>